export default [
  {
    path: '/records/team/create',
    name: 'recordsCreateTeam',
    component: () => import('@/views/records/referrerReward/team/create-team'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/records/team/detail/:id',
    name: 'recordsTeamDetail',
    component: () => import('@/views/records/referrerReward/team/detail'),
    meta: {
      keepAlive: false,
    }
  },
]